export default __webpack_public_path__ + "static/media/HSBC-Bank.a8f75039.webp";